import React from "react";

import axios from "axios";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import { useEffect } from "react";

import "./App.css";
import { useDispatch } from "react-redux";
import { setAddress } from "./redux/addressSlice";
import { TransitionGroup } from "react-transition-group";

import DashBoard from "./components/DashBoard";
import Header from "./components/Header";
import Register from "./components/Register";
import ReferralTree from "./components/ReferralTree";
import SponsorTree from "./components/SponsorTree";
import History from "./components/History";
import Notice from "./components/Notice";
import Loading from "./components/Loading";
import Commission from "./components/Commission";
import preval from "babel-plugin-preval/macro";

export const buildTimestamp = preval`
var today = (new Date().toISOString().slice(0, 17)).replace(/-/g, '').replace(/T/g, '').replace(/:/g, '');
module.exports = +today;
`;

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    console.log(">>>> BUILDTIME: ", buildTimestamp);
    history.push("/");
  }, [history]);

  function checkExists(address) {
    axios
      .get("api/checkExists", {
        params: {
          address: address,
          buildTimestamp: buildTimestamp,
        },
      })
      .then((res) => {
        if (res.data) {
          if (res.data.version) {
            console.log("version: ", res.data.version);
            if (res.data.version > buildTimestamp) {
              alert("App version mismatch. Please refresh the page.");
              document.location.href = "/";
              return;
            }

            if (res.data.exists) {
              history.push("/dashboard");
            } else {
              history.push("/register");
            }
          } else {
            history.push("/dashboard");
          }
        } else {
          history.push("/register");
        }
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response);
          console.log(err.response.data.message);
          alert(err.response.data.message);
        }
      });
  }

  function connectWallet() {
    if (window.tronWeb && window.tronWeb.defaultAddress.base58 === false) {
      alert("Please log in to tronlink");
    } else if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
      console.log(
        "tronWeb:",
        window.tronWeb,
        window.tronWeb.defaultAddress.base58
      );

      let nodeUrl = window.tronWeb.fullNode.host;

      if (process.env.REACT_APP_MODE === "dev") {
        if (nodeUrl === "https://api.nileex.io") {
          console.log("tronLink currently selected the test chain");
        } else {
          alert(
            `Available only on the tron Nile-testnet.\nThe node connected now is '${nodeUrl}'.`
          );
          return;
        }
      } else {
        if (
          nodeUrl === "https://api.trongrid.io" ||
          nodeUrl === "https://api.tronstack.io"
        ) {
          console.log("tronLink currently selected the main chain");
        } else {
          alert(
            `Available only on the tron mainnet.\nThe node connected now is '${nodeUrl}'.`
          );
          return;
        }
      }

      history.push("/loading");
      dispatch(setAddress(window.tronWeb.defaultAddress.base58));
      checkExists(window.tronWeb.defaultAddress.base58);
    } else if (window.tronWeb === undefined) {
      alert(
        "This browser is not available. Tronlink dApp browser or Tronlink extension required."
      );
    }
  }

  function Connection() {
    return (
      <div>
        <div className="diverseTitle"></div>
        <div className="white.sh"></div>
        <div className="dark_sh connect-btn" onClick={connectWallet}>
          {process.env.REACT_APP_MODE === "dev" ? (
            <span className="Connect-to-TronLink dev">
              Connect to TronLink {process.env.REACT_APP_MODE}
            </span>
          ) : (
            <span className="Connect-to-TronLink">Connect to TronLink</span>
          )}
        </div>
        <div className="service-inspection">
          System is not accessible from <strong>20:00</strong> to{" "}
          <strong>20:10</strong>(UTC based) daily due to service inspection.
        </div>
        <div className="help-center">
          <a href="mailto:support@metabridgeinvestment.com">
            Help center : support@metabridgeinvestment.com
          </a>
          <p>© 2021 MetaBridge. build {buildTimestamp}</p>
        </div>
        <div className="diverseFoot"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <TransitionGroup className="main-container">
        <Switch location={location}>
          <Route exact path="/dashboard" component={DashBoard} />
          <Route path="/sponsor" component={SponsorTree} />
          <Route path="/commission" component={Commission} />
          <Route path="/notice" component={Notice} />
          <Route path="/referral" component={ReferralTree} />
          <Route path="/history" component={History} />
          <Route path="/loading" component={Loading} />
          <Route path="/register" component={Register} />
          <Route path="/" component={Connection} />
        </Switch>
      </TransitionGroup>
    </div>
  );
}

export default App;
